module.exports = "/next-static/_next/static/images/block_image_stream_anywhere-0e5f58757573154844bf2c7758e301a8.png";